var React = require('react');

function Download (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.50586 11.75L1.97348 13.6138C2.05492 13.9383 2.24293 14.2263 2.50761 14.4322C2.7723 14.6381 3.09849 14.7499 3.43432 14.75H14.6376C14.9735 14.7499 15.2997 14.6381 15.5643 14.4322C15.829 14.2263 16.017 13.9383 16.0985 13.6138L16.5661 11.75M9.03598 10.25V1.25V10.25ZM9.03598 10.25L6.02393 7.25L9.03598 10.25ZM9.03598 10.25L12.048 7.25L9.03598 10.25Z","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Download.defaultProps = {"width":"18","height":"16","viewBox":"0 0 18 16","fill":"none"};

module.exports = Download;

Download.default = Download;
